import { useEffect } from 'react'
import { SiteNav } from '../components/SiteNav'
import { setPageMeta } from '../utils'

export function TermsPage() {
  useEffect(() => {
    setPageMeta({
      title: 'Terms of Service | arisk.ai',
      description: 'Terms of service for arisk.ai: your responsibilities, limitations of liability, and how the service is provided.',
      canonical: 'https://arisk.ai/terms',
    })
  }, [])

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-neutral-900 text-gray-800 dark:text-neutral-200">
      <SiteNav />

      {/* Content */}
      <div className="max-w-2xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">Terms of Service</h1>
        <p className="text-xs text-gray-400 dark:text-neutral-500 mb-10">Last updated: January 2026</p>

        <div className="space-y-10 text-sm text-gray-600 dark:text-neutral-400 leading-relaxed">

          <section>
            <h2 className="text-base font-semibold text-gray-900 dark:text-white mb-3">Acceptance</h2>
            <p>
              By using arisk.ai you agree to these terms. If you do not agree, please do not use the
              service.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 dark:text-white mb-3">What the service does</h2>
            <p>
              arisk.ai is a browser-based tool that helps you redact sensitive words from text before
              sharing it with AI systems. All processing happens locally in your browser. We do not
              receive, store, or process your text.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 dark:text-white mb-3">Provided as-is</h2>
            <p>
              arisk.ai is provided without warranties of any kind, express or implied. We make no
              guarantees about the accuracy, completeness, or suitability of the tool for any
              particular purpose. You use it at your own risk.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 dark:text-white mb-3">Your responsibility</h2>
            <p>
              You are solely responsible for determining whether arisk.ai is appropriate for your
              use case, verifying that redaction is complete before sharing any text, and complying
              with any professional, regulatory, or contractual obligations that apply to you. This
              tool is an aid to your judgement, not a substitute for it.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 dark:text-white mb-3">Limitation of liability</h2>
            <p>
              To the fullest extent permitted by law, arisk.ai and its operators shall not be liable
              for any direct, indirect, incidental, or consequential damages arising from your use of
              or inability to use the service, including any losses arising from inadvertent disclosure
              of sensitive information.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 dark:text-white mb-3">Acceptable use</h2>
            <p>
              You agree to use arisk.ai only for lawful purposes. You must not attempt to reverse
              engineer, disrupt, or misuse the service.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 dark:text-white mb-3">Changes</h2>
            <p>
              We may update these terms at any time. The date at the top of this page reflects the
              most recent revision. Continued use of arisk.ai after changes are posted constitutes
              acceptance of the updated terms.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-gray-900 dark:text-white mb-3">Contact</h2>
            <p>
              Questions about these terms can be sent to{' '}
              <a
                href="mailto:hello@arisk.ai"
                className="text-blue-600 dark:text-blue-400 hover:underline"
              >
                hello@arisk.ai
              </a>
              {' '}or submitted through the feedback form on the main page.
            </p>
          </section>

        </div>
      </div>
    </div>
  )
}
